import { render } from "./AppImageSettingsModal.vue?vue&type=template&id=8b15a9c2&scoped=true&ts=true"
import script from "./AppImageSettingsModal.vue?vue&type=script&lang=ts"
export * from "./AppImageSettingsModal.vue?vue&type=script&lang=ts"

import "./AppImageSettingsModal.vue?vue&type=style&index=0&id=8b15a9c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b15a9c2"]])

export default __exports__